import router from '../../../router/router';
import { warnFeedBack } from '../../../Toast';

/**
 * Reacts when the client the user is looking at is deleted by somebody
 * else. The dashboard soft-deletes it, the LiveQuery subscription in
 * plugins/common/clients.js has a `deleted != true` constraint, so the
 * row leaves that query and arrives here as clients/DELETE.
 */
export default function createFocusedClientGuard() {
	return store => {
		store.subscribe((mutation, state) => {
			if (mutation.type !== 'clients/DELETE') { return }

			const deletedId = mutation.payload && mutation.payload.id;
			if (!deletedId) { return }
			if (deletedId !== state.clients.focusedClientId) { return }

			store.commit('clients/CLEAR_FOCUSED_CLIENT');
			warnFeedBack("Der ausgewählte Klient wurde gelöscht.");

			// The router guard only runs on navigation, so it cannot
			// help a user already sitting on such a route. The catch is
			// required: vue-router rejects a redundant navigation.
			const needsFocus = router.currentRoute.matched
				.some(record => record.meta.requiresFocus);
			if (needsFocus) {
				router.push({ name: 'Root' }).catch(() => {});
			}
		})
	}
}
